<template>
  <div
    :data-list-name="list.name"
    class="row product-list-page">
    <product-row-item
      v-for="(item, index) in list.items"
      :class="itemClass"
      :item="mappedItem(item)"
      :list-name="list.name"
      :index="index"
      :key="item.prodID"
      :hover="hover"
      :sale-only="saleOnly"
      :no-colors="noColors"/>
  </div>
</template>

<style scoped>
</style>

<script>
import axios from 'axios'
import Vue from 'vue'
import { jrNotifyEx } from '../../bootstrap'
import ProductRowItem from './ProductRowItem.vue'

export default {
    components: {
        'product-row-item': ProductRowItem
    },

    props: {
        listType: {
            type: String,
            default: null
        },
        listId: {
            type: String,
            default: null
        },
        minRating: {
            type: String,
            default: '4.5'
        },
        minReviews: {
            type: String,
            default: '5'
        },
        days: {
            type: String,
            default: '60'
        },
        count: {
            type: String,
            default: '21'
        },
        offset: {
            type: String,
            default: null
        },
        itemClass: {
            type: String,
            default: null
        },
        noColors: {
            type: String,
            default: null
        },
        saleOnly: {
            type: Boolean,
            default: false
        },
        hover: {
            type: Number,
            default: 1
        }
    },

    data () {
        return {
            list: {
                items: []
            },
        }
    },

    async created () {
        try {
            var url = this.queryUrl()
            if (url) {
                const response = await axios.get(url)
                this.list = response.data.data
            }
        } catch (e) {
            jrNotifyEx(e)
        }
    },

    methods: {
        imageUrl (item, size, id) {
            return item.baseImageUrl + '/' + size + '/' + id + '.jpg'
        },
        mappedItem (item) {
            const self = this
            item.master_style = item.master_style || item.style
            item.colors = $.map(item.sortedColors, function (swatch) {
                return Vue.util.extend(swatch, {
                    colorImageUrl: self.imageUrl(item, item.colorImageSize, swatch.colorImageID),
                    swatchImageUrl: self.imageUrl(item, item.swatchImageSize, swatch.swatchImageID)
                })
            })
            return item
        },
        queryUrl () {
            var url = null
            if ((this.listType == 'category') ||
                (this.listType == 'subcategory') ||
                (this.listType == 'salecategory') ||
                (this.listType == 'group')) {
                if (this.listId) {
                    url = '/' + this.listType + '/' + this.listId + '/list'
                }
            }

            if ((this.listType == 'popular') ||
                (this.listType == 'trending')) {
                url = '/' + this.listType + '/list/' + (this.days || '60')
            }

            if ((this.listType == 'top-rated')) {
                url = '/' + this.listType + '/list/' + (this.minRating || '4.75') + '/' + (this.minReviews || '5')
            }

            if (url) {
                if (this.count) {
                    url += '/' + this.count
                    if (this.offset) {
                        url += '/' + this.offset
                    }
                }
            }

            return url
        }
    }
}
</script>
